import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import DSComboBox from '@elliemae/ds-basic/form/ComboBox';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ComboBox = /*#__PURE__*/function (_Component) {
  _inherits(ComboBox, _Component);

  var _super = _createSuper(ComboBox);

  function ComboBox(props) {
    var _this;

    _classCallCheck(this, ComboBox);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value
    };
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ComboBox, [{
    key: "handleChange",
    value: function handleChange(value) {
      var onValue = this.props.onValue; // some how this is executed before handleBlur, and handleBlur before the value is set
      // causing the value to be the same as the prevProp
      // todo: find a better solution to this

      setTimeout(function () {
        return onValue(value);
      }, 1);
      this.setState({
        value: value
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var onValue = this.props.onValue;
      var value = this.state.value;
      onValue(value);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      return /*#__PURE__*/React.createElement(DSComboBox, _extends({}, this.props, {
        menuIsOpen: true,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        value: value
      }));
    }
  }]);

  return ComboBox;
}(Component);

_defineProperty(ComboBox, "defaultProps", {
  onValue: function onValue() {
    return null;
  }
});

export default ComboBox;
//# sourceMappingURL=ComboBox.js.map
